import { useNavigate } from 'react-router-dom'

import { useSendFeedbackMutation } from 'src/Redux/sendFeedbackApi'
import { campaignsList } from 'src/Router/routes'

import { SurveyFormValues } from './helpers'

interface SendFeedback {
  loading: boolean
  onSendFeedback: (data: SurveyFormValues) => Promise<void>
}

export const useSendFeedBack = (): SendFeedback => {
  const navigate = useNavigate()
  const [send, { isLoading }] = useSendFeedbackMutation()

  const onSendFeedback = async (data: SurveyFormValues): Promise<void> => {
    await send({
      answer: data.resource,
      subAnswer: data.description || '',
    })
    navigate(campaignsList)
  }
  return { loading: isLoading, onSendFeedback }
}
